import { render, staticRenderFns } from "./CartNavigationDrawer.vue?vue&type=template&id=70e17fb8"
import script from "./CartNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./CartNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListCartNavigationDrawer: require('/home/leodev/Sistemas/loja/components/ListCartNavigationDrawer.vue').default})
